export const SETCATEGORY = 'filter/setcategory';
export const SETAUTHOR = 'filter/setauthor';
export const SETKEYWORD = 'filter/setkeyword';